import React from 'react'

import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

import SearchField from 'components/atoms/SearchField'
import DataTable from 'components/organisms/DataTable'
import SubmitButton from 'components/atoms/buttons/SubmitButton'
import DropdownSelect from 'components/molecules/DropdownSelect'
import PaginationControl from 'components/organisms/PaginationControl'

import { groupColumns } from './'
import { DATE_DROPDOWN_OPTIONS } from 'constants/tables'

const styles = theme => ({
  root: {
    marginBottom: theme.spacing(1),
  },
  table: {
    marginTop: theme.spacing(6),
  },
  menu: {
    width: 180,
  },
  content: {
    flex: 1,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  submitButton: {
    marginLeft: theme.spacing(3),
  },
})

const GroupDataOverview = ({
  groups,
  classes,
  filters,
  tableLoading,
  onPageChange,
  onExportClick,
  onRangeChange,
  selectedRange,
  onSearchChange,
  onTableRowClick,
  onTableSortClick,
  onTableSelectableClick,
}) => (
  <div className={classes.root}>
    <div className={classes.content}>
      <div className={classes.header}>
        <DropdownSelect
          text="Total data for "
          selected={selectedRange}
          onChange={onRangeChange}
          options={DATE_DROPDOWN_OPTIONS}
        />
        <div className={classes.header}>
          <SearchField onChange={onSearchChange} width={110}/>
          <SubmitButton
              autoFocus
              size="medium"
              type="submit"
              color="primary"
              variant="primary"
              onClick={onExportClick}
              className={classes.submitButton}>
            Download reports...
          </SubmitButton>
        </div>
      </div>
      <DataTable
        key="Group table"
        dataProvider={groups}
        columns={groupColumns}
        className={classes.table}
        tableLoading={tableLoading}
        onRowClick={onTableRowClick}
        onSortClick={onTableSortClick}
        onSelectableClick={onTableSelectableClick}
        emptyStateTitle="Looks like you need to create some groups!"
        emptyStateDescription="You can create groups within the Manage Traps tab. Use groups to help you see reporting on a specific set of traps for even better insights."
      />
      <PaginationControl
        pagination={filters.pagination}
        onPageChange={onPageChange}
      />
    </div>
  </div>
)

GroupDataOverview.propTypes = {
  groups: PropTypes.object,
  filters: PropTypes.object,
  classes: PropTypes.object,
  onTabClick: PropTypes.func,
  tableData: PropTypes.object,
  tableLoading: PropTypes.bool,
  onPageChange: PropTypes.func,
  onExportClick: PropTypes.func,
  onRangeChange: PropTypes.func,
  onSearchChange: PropTypes.func,
  selectedRange: PropTypes.object,
  onTableRowClick: PropTypes.func,
  onTableSortClick: PropTypes.func,
  onTableSelectableClick: PropTypes.func,
}

export default withStyles(styles)(GroupDataOverview)



// WEBPACK FOOTER //
// ./src/containers/groups/GroupDataOverview/GroupDataOverview.js